/** Ported from QR2 (apps/scan/feedback.ts): beep and vibration on scans. Audio needs a user gesture first. */
let ctx: AudioContext | null = null;

export function primeAudio() {
  if (ctx) return;
  try {
    ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  } catch {
    ctx = null;
  }
}

function tone(freq: number, start: number, duration: number, gain = 0.15) {
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, ctx.currentTime + start);
  g.gain.linearRampToValueAtTime(gain, ctx.currentTime + start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + duration);
  osc.connect(g).connect(ctx.destination);
  osc.start(ctx.currentTime + start);
  osc.stop(ctx.currentTime + start + duration + 0.02);
}

export function beepScan() {
  primeAudio();
  tone(1320, 0, 0.09);
  navigator.vibrate?.(50);
}

export function beepSuccess() {
  primeAudio();
  tone(880, 0, 0.09);
  tone(1320, 0.1, 0.14);
  navigator.vibrate?.([40, 40, 80]);
}

export function beepError() {
  primeAudio();
  tone(220, 0, 0.25, 0.2);
  navigator.vibrate?.([120, 60, 120]);
}
